import {
  DEFAULT_FILE_FORMAT_ICON,
  FILE_CONTENT_TYPE_LABELS,
  FILE_FORMAT_ICONS,
  FILE_MIME_FORMAT_KEYS,
} from 'src/services/consts/companyFile.const'

function formatContentTypeKey(key) {
  if (!key) return ''
  return (
    FILE_CONTENT_TYPE_LABELS[key] ??
    String(key)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  )
}

export function getFileContentTypeLabel(fileContentType) {
  const keys = Array.isArray(fileContentType)
    ? fileContentType.filter(Boolean)
    : fileContentType
      ? [fileContentType]
      : []

  if (!keys.length) return '—'

  return keys.map(formatContentTypeKey).join(', ')
}

function normalizeFileExtension(value) {
  const raw = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/^\./, '')
  return raw.split(/[?#]/)[0] || ''
}

function resolveFormatKey({ fileType, mimeType, fileName }) {
  const fromType = normalizeFileExtension(fileType)
  if (fromType && FILE_FORMAT_ICONS[fromType]) return fromType

  const fromName = normalizeFileExtension(fileName?.split('.').pop())
  if (fromName && FILE_FORMAT_ICONS[fromName]) return fromName

  const mime = String(mimeType ?? '').toLowerCase()
  const mimeMatch = Object.entries(FILE_MIME_FORMAT_KEYS).find(([needle]) => mime.includes(needle))
  if (mimeMatch) return mimeMatch[1]

  return fromType || fromName || ''
}

/** Material icon name for a file row (format-driven, not content category). */
export function getFileFormatIcon({ fileType, mimeType, fileName } = {}) {
  const formatKey = resolveFormatKey({ fileType, mimeType, fileName })
  return FILE_FORMAT_ICONS[formatKey] ?? DEFAULT_FILE_FORMAT_ICON
}

export function refactorCompanyFile(raw, fileIdFromKey = '') {
  if (!raw || typeof raw !== 'object') return null

  const fileId = raw.file_id ?? raw.fileId ?? fileIdFromKey
  if (!fileId) return null

  return {
    fileId,
    fileName: raw.file_name ?? raw.fileName ?? '',
    fileType: raw.file_type ?? raw.fileType ?? '',
    fileContentType: raw.file_content_type ?? raw.fileContentType ?? '',
    sourceUrl: raw.source_url ?? raw.sourceUrl ?? '',
    uploadTime: raw.upload_time ?? raw.uploadTime ?? '',
    mimeType: raw.mime_type ?? raw.mimeType ?? '',
    userId: raw.user_id ?? raw.userId ?? '',
    active: raw.active ?? false,
    main: raw.main ?? false,
  }
}

function sortCompanyFiles(files) {
  return [...files].sort((a, b) => {
    if (a.main !== b.main) return a.main ? -1 : 1

    const aTime = Date.parse(a.uploadTime) || 0
    const bTime = Date.parse(b.uploadTime) || 0
    if (aTime !== bTime) return bTime - aTime

    return (a.fileName || '').localeCompare(b.fileName || '', undefined, { sensitivity: 'base' })
  })
}

export function refactorCompanyFiles(raw) {
  if (!raw) return []

  let files = []

  if (Array.isArray(raw)) {
    files = raw.map((entry) => refactorCompanyFile(entry)).filter(Boolean)
  } else if (typeof raw === 'object') {
    files = Object.entries(raw)
      .map(([key, entry]) => refactorCompanyFile(entry, key))
      .filter(Boolean)
  }

  return sortCompanyFiles(files)
}
